<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <b-icon
          size="is-large"
          icon="sync-alt"
          custom-class="fa-spin fa-5x"
        ></b-icon>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  data() {
    return {
      returnUrl: this.$route.query.returnUrl
        ? decodeURIComponent(this.$route.query.returnUrl)
        : '/'
    }
  },
  computed: {
    ...mapGetters('sesion', ['sesion'])
  },
  mounted() {
    this.loginUsuario()
  },
  methods: {
    loginUsuario() {
      const self = this
      self.$store
        .dispatch('sesion/login')
        .then(() => {
          self.$store
            .dispatch('sesion/getSesion', {
              nombreUsuario: this.sesion.nombreUsuario
            })
            .then(() => {
              self.$router.push(this.returnUrl)
            })
            .catch((_) => self.$router.push('/no-configurado'))
        })
        .catch((err) => this.procesarError(err))
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.login-hr {
  border-color: #000;
}
</style>
